import { ArrowBack, ArrowForward } from "@mui/icons-material";
import {
  Box,
  Button,
  Card,
  Checkbox,
  CircularProgress,
  Container,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import React, { useState }  from "react";

const NewCustomerComponent = ({
  step,
  setStep,
  handleChange,
  customerDetails,
  //handleNextStep,
  handleCheck,
  handleSaveCustomerDetails,
  keyLoading,
}) => {

  const handleContinue = (e) => {
    if (e.key === "Enter") {
      setStep(step + 1);
    }
  }
  //console.log("step", step);
  
 
  return (
    <Card>
      <Box p={4}>
        <Box mb={3} textAlign="center">
          <h2>New Customer</h2>
        </Box>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              required
              variant="outlined"
              name="firstName"
              label="First Name"
              type="text"
              onChange={handleChange}
              value={customerDetails.firstName}
              onKeyDown={handleContinue}
              helperText={"Required Field"}
              fullWidth
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
               variant="outlined"
               name="lastName"
               label="Last Name"
               type="lastName"
               onChange={handleChange}
               value={customerDetails.lastName}
               onKeyDown={handleContinue}
               fullWidth
            />
          </Grid>

          <Grid item xs={12}>
            <FormControl>
              <FormGroup aria-label="position" row>
                <FormControlLabel
                  control={
                    <Checkbox
                      value={customerDetails.notify}
                      onChange={handleCheck}
                      checked={customerDetails.notify}
                      name="notify"
                    />
                  }
                  label="Notify me?"
                />
              </FormGroup>
            </FormControl>
          </Grid>

          <Grid item xs={12}>
            <TextField
              required={customerDetails.notify ? true : false}
              variant="outlined"
              name="mobile"
              label="Mobile number"
              type="text"
              onChange={handleChange}
              value={customerDetails.mobile}
              helperText={customerDetails.notify ? "Required Field" : ""}
              onKeyDown={handleContinue}
              fullWidth
            />
            
          </Grid>
          <Grid item xs={12}>
          {customerDetails.notify ? "Or" : ""}
          </Grid>

          <Grid item xs={12}>
            <TextField
              required={customerDetails.notify ? true : false}
              variant="outlined"
              name="email"
              label="Email Address"
              type="email"
              onChange={handleChange}
              value={customerDetails.email}
              helperText={customerDetails.notify ? "Required Field" : ""}
              onKeyDown={handleContinue}
              fullWidth
            />
          </Grid>



          <Grid item xs={12}>
            <Box display="flex" alignItems={"center"} justifyContent={"space-between"} mt={1}>
              <Button
                variant="contained"
                size="medium"
                color="secondary"
                onClick={() => setStep(step - 1)}
                style={{ marginRight: "10px" }} 
              >
                <ArrowBack fontSize="small" sx={{ marginRight: "5px" }} /> Back
              </Button>
              {/* {customerDetails.type === "new" && (
                keyLoading ? (
                  <CircularProgress
                    style={{
                      height: "40px",
                      width: "40px",
                      marginLeft: "10px",
                      position: "relative",
                      top: "20px",
                    }}
                    color="secondary"
                  />
                ) : (
                  <Button
                    variant="contained"
                    size="medium"
                    disabled={
                      // customerDetails.firstName.length && customerDetails.lastName.length 
                      //   ? (!customerDetails.notify && customerDetails.mobile) ? false : (customerDetails.notify && !customerDetails.mobile) ? true : false
                      //   : true
                      customerDetails?.firstName?.length ? false : true
                    }
                    color="primary"
                    onClick={handleSaveCustomerDetails}
                    sx={{ margin: "10px"}}
                  >
                    Save Customer Details
                  </Button>
                )
              )} */}
              {/* {customerDetails.type === "resume" || customerDetails.type === "existing" ? (
                <Button
                  variant="contained"
                  size="medium"
                  //disabled={
                  //customerDetails.firstName.length
                  // && customerDetails.lastName.length && customerDetails.mobile && customerDetails.email
                  //     ? 
                  //     // (!customerDetails.notify && customerDetails.mobile) ? false : (customerDetails.notify && !customerDetails.mobile) ? true : 
                  //      false
                  //     : true
                  // }
                  color="primary"
                  onClick={() => setStep(step + 1)}
                  
                >
                  Continue <ArrowForward fontSize="small" />
                </Button> */}
                {customerDetails.type === "new" && (
                keyLoading ? (
                  <CircularProgress
                    style={{
                      height: "40px",
                      width: "40px",
                      marginLeft: "10px",
                      position: "relative",
                      top: "20px",
                    }}
                    color="secondary"
                  />
              ) : (
                <Button
                  variant="contained"
                  size="medium"
                  disabled={
                    customerDetails?.firstName?.length ? false : true
                  }
                  color="primary"
                  onClick={handleSaveCustomerDetails}
                  //onClick={() => setStep(step + 1)}
                  
                >
                  Save and Continue <ArrowForward fontSize="small" />
                </Button>

              ))}
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Card>
  );
};

export default NewCustomerComponent;
